import { render, staticRenderFns } from "./departure_info.vue?vue&type=template&id=3bd93f08&"
import script from "./departure_info.vue?vue&type=script&lang=js&"
export * from "./departure_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports